import { Fragment } from "react";

import Layout from "@metronic/layout/components/Layout";

import { ROUTES_DPR } from "../modules/daily-production-report"
import { ROUTES_EXPORT_MONITORING } from "../modules/export-monitoring";
import { ROUTES_IMPORT_MONITORING } from "../modules/import-monitoring";
import { ROUTES_INTERPLANT } from "../modules/interplant-transfer";
import { ROUTES_LOGISTICS } from "../modules/logistics";
import { ROUTES_NON_RAW_MATS } from "../modules/non-raw-mats";
import { ROUTES_RACO } from "../modules/raco";
import { ROUTES_RAW_MATS } from "../modules/raw-mats";
import { ROUTES_SALES_CONTRACT } from "../modules/sales-contract";
import { ROUTES_SYSTEM_MAINTENANCE } from "../modules/system-maintenance";
import { ROUTES_USER_MAINTENANCE } from "../modules/system-user-maintenance";
import { ROUTES_TANK_SOUNDING } from "../modules/tank-sounding";
import { ROUTES_TRADE_SUMMARY } from "../modules/trade-summary";
import { ROUTES_UCAP } from "../modules/ucap";

import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";


const MODULE_ROUTES = [

  ROUTES_TRADE_SUMMARY,
  ROUTES_LOGISTICS,
  ROUTES_TANK_SOUNDING,
  ROUTES_RAW_MATS,
  ROUTES_NON_RAW_MATS,
  ROUTES_SALES_CONTRACT,
  ROUTES_UCAP,
  ROUTES_RACO,
  ROUTES_EXPORT_MONITORING,
  ROUTES_IMPORT_MONITORING,
  ROUTES_USER_MAINTENANCE,
  ROUTES_SYSTEM_MAINTENANCE,
  ROUTES_INTERPLANT,
  ROUTES_DPR
]


// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (Routes) => {
  const LayoutRoutes = []

  if (Routes) {
    Routes.filter(route => {
      // ** Checks if Route layout or Default layout matches current layout

      let RouteTag = PrivateRoute

      // ** Check for public or private route
      if (route.meta) {
        RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute
      }

      if (route.element) {
        route.element = (
          <Fragment >
            <RouteTag route={route}>{route.element}</RouteTag>
          </Fragment>
        )
      }

      // Push route to LayoutRoutes
      LayoutRoutes.push(route)
      return LayoutRoutes
    })

  }
  return LayoutRoutes
}



const getRoutes = () => {

  const AllRoutes = []

  // const TankSounding = [{
  //   ...ROUTES_TANK_SOUNDING[0], children: MergeLayoutRoutes(ROUTES_TANK_SOUNDING[0].children)
  // }];

  // const LayoutRoutes = TankSounding;
  // console.log("🚀 ~ getRoutes ~ TankSounding:", TankSounding)

  const LayoutRoutes = [];
  MODULE_ROUTES.forEach(route => {
    const moduleRoute = { ...route[0], children: MergeLayoutRoutes(route[0].children) }
    LayoutRoutes.push(moduleRoute)
  })

  AllRoutes.push({
    element: <Layout />,
    children: LayoutRoutes
  })

  return AllRoutes
}

export { getRoutes }
